import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PageNotFound from "./pages/PageNotFound";
import ProjectsIndex from "./pages/Projects/Index";
import ProjectsShow from "./pages/Projects/Show";
import ProjectsDemo from "./pages/Projects/Demo";
import Footer from "./components/Footer";
const App = () => {
	return (
		<Router >
			<NavBar />
			<div className="container mx-auto">
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/projects" element={<ProjectsIndex />} />
					<Route path="/projects/:slug" element={<ProjectsShow />} />
					<Route path="/projects/:slug/demo" element={<ProjectsDemo />} />

					<Route path="*" element={<PageNotFound />} />
				</Routes>
			</div>
			<Footer/>
		</Router>
	);
};
export default App;
